<template>
  <BaseFetchData :action="fetchData">
    <!-- props
      fetchData, status.loading, status.resolved, status.rejected, rejectReason
    -->
    <template #default="fetchDataProps">
      <BaseVeeForm v-if="fetchDataProps.status.resolved" :action="onSend">
        <!-- formProps
          isIdle, isPending, isResolved, isRejected, invalid
          errors, submit
        -->
        <template #default="formProps">
          <div>
            <div class="bg-white p-4 rounded-t space-y-4">
              <BaseFormSelectFieldWithValidator
                v-model="formData.third_party_service_id"
                :validator="{
                  name: 'third party service',
                  vid: 'third_party_service_id',
                  rules: {
                    required: true,
                  },
                }"
                :field="{
                  id: 'third_party_service',
                  label: 'From',
                  required: true,
                  defaultOptionLabel: 'Select sending service...',
                  options: thirdPartyServiceOptions,
                }"
                :disabled="formProps.isPending"
              />
              <BaseFormSelectFieldWithValidator
                v-model="formData.phone_number_id"
                :validator="{
                  name: 'phone number',
                  vid: 'phone_number_id',
                  rules: {
                    required: true,
                  },
                }"
                :field="{
                  id: 'phone_number_id',
                  label: 'To',
                  required: true,
                  defaultOptionLabel: 'Select contact phone...',
                  options: phoneNumberOptions,
                }"
                :disabled="formProps.isPending"
              />
              <div>
                <BaseFormTextareaFieldWithValidator
                  v-model="formData.sms_message_content"
                  :validator="{
                    name: 'content',
                    vid: 'content',
                    rules: {
                      required: true,
                    },
                  }"
                  :field="{
                    id: 'content',
                    label: 'Content',
                  }"
                  :disabled="formProps.isPending"
                />
                <div class="mt-2 text-xs text-teal-700">
                  <span>{{ contentStats.totalChars }} characters</span> / <span />{{
                    contentStats.totalMessages
                  }}
                  messages
                </div>
              </div>
            </div>
            <div class="bg-gray-50 p-4 rounded-b space-x-2">
              <BaseButton primary small :disabled="formProps.invalid || formProps.isPending">
                Send
              </BaseButton>
              <BaseButton
                type="button"
                ghost
                small
                :disabled="formProps.isPending"
                @click="onCancel"
              >
                Cancel
              </BaseButton>
            </div>
          </div>
        </template>
      </BaseVeeForm>
    </template>
  </BaseFetchData>
</template>

<script>
import {
  accountThirdPartyServicesClient,
  contactsClient,
  contactSmsMessagesClient,
} from '@/api/clients';

export default {
  props: {
    contactRequest: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      thirdPartyServiceOptions: [],
      phoneNumberOptions: [],
      formData: {
        contact_request_id: this.contactRequest.id,
        third_party_service_id: null,
        phone_number_id: null,
        sms_message_content: '',
      },
    };
  },
  computed: {
    contentStats() {
      return {
        totalChars: this.formData.sms_message_content.length,
        totalMessages: Math.ceil(this.formData.sms_message_content.length / 70),
      };
    },
  },
  methods: {
    fetchData() {
      return Promise.all([this.fetchThirdPartyServices(), this.fetchContact()]);
    },
    fetchThirdPartyServices() {
      return accountThirdPartyServicesClient
        .list(this.contactRequest.accountId, {
          params: {
            filter: {
              channel: 'sms',
              active: true,
            },
          },
        })
        .then((response) => {
          this.thirdPartyServiceOptions = response.data.data.map((item) => ({
            label: item.config.name,
            value: item.id,
          }));

          if (this.thirdPartyServiceOptions.length === 1) {
            const [first] = this.thirdPartyServiceOptions;
            this.formData.third_party_service_id = first.value;
          }
        });
    },
    fetchContact() {
      return contactsClient
        .read(this.contactRequest.contactId, {
          include: 'phoneNumbers',
        })
        .then((response) => {
          this.phoneNumberOptions = response.data.phone_numbers
            .filter((item) => item.number_type === 'mobile')
            .map((item) => ({ label: item.number, value: item.id }));

          const defaultPhoneNumber = this.phoneNumberOptions.find((phoneNumber) =>
            phoneNumber.label.includes(this.contactRequest.phone.replace(/\D/g, ''))
          );

          if (defaultPhoneNumber) {
            this.formData.phone_number_id = defaultPhoneNumber.value;
          }
        });
    },
    onSend() {
      return contactSmsMessagesClient
        .store(this.contactRequest.contactId, this.formData)
        .then(() => {
          this.$emit('created');
        });
    },
    onCancel() {
      this.$emit('cancel');
    },
  },
};
</script>
